export const CHANGE_MONTH = 'CHANGE_MONTH'
export const DAY_SELECTED = 'DAY_SELECTED'
export const WEEK_SELECTED = 'WEEK_SELECTED'
export const EVENT_ADDED = 'eventAdded'
export const EVENT_DELETED = 'eventDeleted'
export const SHOW_ADD_EVENT_FORM = 'update:show'
export const SHOW_DETAILS_EVENT_MODAL = 'update:show'
